//#region src/order_update_toasts_mode.ts
var OrderUpdateToastsMode = /* @__PURE__ */ function(OrderUpdateToastsMode) {
	OrderUpdateToastsMode["None"] = "none";
	OrderUpdateToastsMode["AllUpdates"] = "all-updates";
	OrderUpdateToastsMode["ScannedItemsAndDiscounts"] = "scanned-items-and-discounts";
	OrderUpdateToastsMode["DiscountsOnly"] = "discounts-only";
	return OrderUpdateToastsMode;
}(OrderUpdateToastsMode || {});
//#endregion
export { OrderUpdateToastsMode };

//# sourceMappingURL=order_update_toasts_mode.js.map